import { Box, Breadcrumbs, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Article } from "../../types/Article";
import { Close, PhotoLibraryRounded, RefreshRounded, Restore } from "@mui/icons-material";
import { useEffect, useState } from "react";
import validator from "validator";
import { ImageBrowser, ImageInfo } from "../ImageBrowser";
import { UploadImage } from "../../types/UploadImage";

export type ArticleEditorImageSelectorProps = {
    article: Article,
    onChange?: (url: string) => void,
};
export const ArticleEditorImageSelector = (props: ArticleEditorImageSelectorProps) => {
    const { article, onChange } = props;

    const [imageUrl, setImageUrl] = useState(article.imageUrl);
    const [openBrowser, setOpenBrowser] = useState(false);

    const handleImageUrlOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const value = event.target.value;
        setImageUrl(value);
    };

    const openDialog = () => {
        setOpenBrowser(true);
    };

    const closeDialog = () => {
        setOpenBrowser(false);
    };

    const handleResetOnClick = () => {
        setImageUrl(article.imageUrl);
    };

    const handleImageBrowserOnSelect = (imageInfos: UploadImage[]) => {
        if (imageInfos.length > 0) {
            setImageUrl(imageInfos[0].downloadUrl);
            closeDialog();
        }
    };

    useEffect(() => {
        onChange && onChange(imageUrl);
    }, [imageUrl])

    return (
        <>
            <Stack direction="row" spacing={1}>
                <TextField 
                    value={imageUrl}
                    onChange={handleImageUrlOnChange}
                    variant="standard"
                    label="Image or Image Url"
                    placeholder="Enter image url or upload an image"
                    error={imageUrl.trim().length > 0 && !validator.isURL(imageUrl)}
                    helperText="Enter a valid url."
                    sx={{
                        flexGrow: 1
                    }}
                />
                <Stack spacing={1} direction="row" sx={{ height: 48 }}>
                    <IconButton 
                        sx={{
                            alignSelf: "end",
                        }}
                        onClick={handleResetOnClick}
                    >
                        <RefreshRounded />
                    </IconButton>
                    <Button
                        startIcon={<PhotoLibraryRounded />}
                        variant="outlined"
                        sx={{
                            alignSelf: "end",
                        }}
                        onClick={openDialog}
                    >
                        Browse...
                    </Button>
                </Stack>
            </Stack>
            <ImageBrowser 
                path={`Articles/${article.id}`}
                collectionPath={`Articles/${article.id}/Images`}
                open={openBrowser} 
                onSelected={handleImageBrowserOnSelect}
                onClose={closeDialog}
            />
        </>
    );
};